var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCookerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V3.5C11 2.94772 10.5523 2.5 10 2.5H3C2.44772 2.5 2 2.94772 2 3.5V8.5C2 10.7091 3.79086 12.5 6 12.5H7C9.20914 12.5 11 10.7091 11 8.5Z",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5V2.5H18C20.2091 2.5 22 4.29086 22 6.5V16.5H18",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5V21.5C15 22.0523 15.4477 22.5 16 22.5H17C17.5523 22.5 18 22.0523 18 21.5V16.5",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5V21.5C5 22.0523 5.44772 22.5 6 22.5H7C7.55228 22.5 8 22.0523 8 21.5V12.5",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5V2.5",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V2.5",
    stroke: "#FF6741",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCookerActive);
export default __webpack_public_path__ + "static/media/my_cooker_active.c92b3054acbeb3a797609b0cb42fd34e.svg";
export { ForwardRef as ReactComponent };